"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Doctor = void 0;
var Doctor = /** @class */ (function () {
    function Doctor() {
        this.forename = "";
        this.surname = "";
    }
    return Doctor;
}());
exports.Doctor = Doctor;
//# sourceMappingURL=Doctor.js.map